import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "music", label: "Music" },
  { id: "recent", label: "Recent" },
  { id: "faith", label: "Faith" },
  { id: "collab", label: "Collab" },
  { id: "prayer", label: "Prayer" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-12 lg:px-16 h-16">
        <button
          data-testid="nav-brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
        >
          <span className="h-2 w-2 rounded-full bg-[#D4AF37] group-hover:scale-150 transition-transform" />
          <span className="font-display font-black tracking-[0.25em] text-sm">
            TEKRECK
          </span>
        </button>

        <ul className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-link-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="text-xs uppercase tracking-[0.2em] text-white/70 hover:text-[#D4AF37] transition-colors"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <a
          data-testid="nav-cta-spotify"
          href="https://open.spotify.com/artist/7x9ldSU6voBZpcHMNOGVlw"
          target="_blank"
          rel="noreferrer"
          className="hidden md:inline-flex items-center h-9 px-5 text-xs uppercase tracking-[0.2em] border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-colors"
        >
          Spotify
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 backdrop-blur-xl border-b border-white/10 px-6 py-6 space-y-4"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="block text-left w-full text-sm uppercase tracking-[0.25em] text-white/80 hover:text-[#D4AF37]"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
